import React from 'react';
import axios from 'axios';

import Loading from '../Loading';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import styles from '../../styles/DynamicModal.module.css';

const ChangeDataCase = ({ caseId, onChangeCaseDataSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [number, setNumber] = React.useState('');
    const [internalNumber, setInternalNumber] = React.useState('');
    const [toCaseNumber, setToCaseNumber] = React.useState('');
    const [applicant, setApplicant] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [dateStart, setDateStart] = React.useState('');
    const [dateCourt, setDateCourt] = React.useState('');
    const [dateEnd, setDateEnd] = React.useState('');
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    const [labelId, setLabelId] = React.useState('');
    const [labelName, setLabelName] = React.useState('');
    const [selectedCategoryId, setSelectedCategoryId] = React.useState('');
    const [categories, setCategories] = React.useState([]);
    const [selectedPhaseId, setSelectedPhaseId] = React.useState('');
    const [phases, setPhases] = React.useState([]);
    const [userId, setUserId] = React.useState('');
    const [dateSubmissionCandidate, setDateSubmissionCandidate] = React.useState('');
    const [dateAMAppointment, setDateAMAppointment] = React.useState('');

    const [loadingCatPh, setLoadingCatPh] = React.useState(true);
    const [warningCatPh, setWarningCatPh] = React.useState('');

    const [successs, setSuccesss] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-info-case?caseId=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Ошибка системы.');
            } else {
                setWarning('');
                setLabelId(response.data.label_id);
                setLabelName(response.data.labelName);
                setSelectedCategoryId(response.data.category_id);
                setSelectedPhaseId(response.data.phase_id);
                setUserId(response.data.user_id);
                setNumber(response.data.number);
                setInternalNumber(response.data.internal_number);
                setToCaseNumber(response.data.toCaseNumber);
                setApplicant(response.data.applicant);
                setRegion(response.data.region);
                setDateStart(response.data.date_start);
                setDateCourt(response.data.date_court);
                setDateSubmissionCandidate(response.data.date_submission_candidate);
                setDateAMAppointment(response.data.date_am_appointment);
                setDateEnd(response.data.date_end);

                setSuccesss(true);
            }
        })
        .catch(error => {
            if (error.response?.data.action == 'logout') {
                window.location.href = '/auth/logout';
            }
            setWarning(`Ошибка при загрузке карточки:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId]);

    React.useEffect(() => {
        setLoadingCatPh(true);

        if (successs) {
            if (selectedCategoryId) {
                axios.get(`/api/phases?categoryId=${selectedCategoryId}`)
                    .then((response) => {
                        setPhases(response.data);
                        setWarningCatPh('');
                    })
                    .catch(error => {
                        console.error('Ошибка при загрузке этапов: ', error);
                        setWarningCatPh('Ошибка при загрузке этапов');
                    })
                    .finally(() => {
                        setLoadingCatPh(false);
                    });
            } else {
                axios.get(`/api/categories?labelId=${labelId}`)
                    .then((response) => {
                        setCategories(response.data);
                        setWarningCatPh('');
                    })
                    .catch((error) => {
                        console.error('Ошибка при загрузке категорий: ', error);
                        setWarningCatPh('Ошибка при загрузке категорий');
                    })
                    .finally(() => {
                        setLoadingCatPh(false);
                    });
            }
        }    
    }, [selectedCategoryId, reload]);

const changeCaseData = () => {
    if (loadingCatPh || !phases.length) {
        return openTimeModal('Этапы исполнения ещё загружаются. Попробуйте позже.', 'error');
    }
    if (!selectedPhaseId) {
        return openTimeModal('Этап исполнения не выбран.', 'error');
    }
    axios.put(`/api/change-case-data`, {
        caseId,
        number,
        internalNumber,
        toCaseNumber,
        applicant,
        region,
        dateStart,
        dateCourt,
        dateSubmissionCandidate,
        dateAMAppointment,
        dateEnd,
        categoryId: selectedCategoryId,
        phaseId: selectedPhaseId,
    })
    .then(() => {
        onChangeCaseDataSuccess();
        openTimeModal('Данные карточки успешно изменены', 'success');
    })
    .catch(error => {
        setStatus(`Ошибка при добавлении или изменении данных карточки: ${error.response?.data.message || error.message}`);
    });
};

React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault(); // Предотвращает стандартное поведение
                changeCaseData();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [loadingCatPh, phases, selectedPhaseId]);

    return (
        loading ? (
            <Loading />
        ) : warning ? (
            <a className={styles.statusPanel}>{warning}</a>
        ) : (
        <>
            <a>Введите номер входящей корреспонденции</a>
            <input type='text' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value)} maxLength='20' placeholder='Номер входящей корреспонденции' required />

            <a>Введите номер</a>
            <input type='text' value={number} onChange={(e) => setNumber(e.target.value)} maxLength='20' placeholder='Номер' />
            
            {labelName == 'Жалобы' && (
                <div className={styles.outliningPanel}>
                    <a className={styles.description}>В настоящее время жалоба связана со следующим номером дела: {toCaseNumber}.<br/>Чтобы изменить эту связь, необходимо удалить текущую карточку и создать новую.</a>
                </div>
            )}

            <div className={styles.requiredFieldsContainer}>
            {loadingCatPh ? <div style={{minHeight: '250px', display: 'flex', alignItems: 'center'}}><Loading /> </div>
            : !selectedCategoryId ? (
                <>
                    <h2 style={{display: 'flex', alignItems: 'center', minHeight: '30px'}}>
                        Выберите категорию
                    </h2>
                    <div style={{marginTop: '20px'}}></div>
                    {warningCatPh ? (
                        <a>{warningCatPh}</a> 
                    ) : (categories.map((category) => (
                        <div className={styles.radioLabel} key={category.id} onClick={() => {setSelectedCategoryId(category.id)}}>
                            <label htmlFor={category.id}>{category.name}</label>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-right-b"><path fill="black" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
                        </div>
                    )
                    ))}
                </>
            ) : (
                <>
                    <h2 style={{display: 'flex', alignItems: 'center'}}>
                        <svg style={{width: '30px', marginRight: '10px', cursor: 'pointer'}} onClick={() => {setSelectedCategoryId('')}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-left-b"><path fill="currentColor" d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z"></path></svg>
                        Выберите этап
                    </h2>
                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                        <a>Вы можете выбрать этап, с которого начнется учёт дела в системе</a>
                        <a className={styles.description}>По умолчанию выбран первый этап по порядку</a>
                    </div>
                    {warningCatPh ? 
                    <a>{warningCatPh}</a> 
                    : Object.entries(
                        phases.reduce((acc, phase) => {
                            if (!acc[phase.order_of_phase]) {
                                acc[phase.order_of_phase] = [];
                            }
                            acc[phase.order_of_phase].push(phase);
                            return acc;
                        }, {})
                    ).map(([orderOfPhase, phaseGroup]) => (
                        <div
                            key={orderOfPhase}
                            className={styles.phaseGroup}
                        >
                            <div className={styles.generalPhases}>
                            {phaseGroup.map((phase) => (
                                <div
                                    className={styles.radioLabel}
                                    key={phase.id}
                                    onClick={() => {setSelectedPhaseId(phase.id)}}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: selectedPhaseId == phase.id ? '#f0f0f0' : 'transparent',
                                        border: '1px solid',
                                        padding: '10px',
                                        margin: '5px 0',
                                        borderColor: selectedPhaseId == phase.id ? 'blue' : 'gray',
                                    }}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>{phase.name}</span>
                                        <span className={styles.description}>
                                            Время выполнения в днях: {phase.time}. Только рабочие дни: {phase.typesch ? 'Да' : 'Нет'}
                                        </span>
                                    </div>
                                    {selectedPhaseId ==phase.id && (
                                        <span style={{ color: 'blue', fontWeight: 'bold' }}>Выбрано</span>
                                    )}
                                </div>
                            ))}
                            </div>
                        </div>
                    ))}
                </>
            )}
            </div>

            <a>Введите должника</a>
            <input type='text' value={applicant} onChange={(e) => setApplicant(e.target.value)} maxLength='100' placeholder='Должник' />

            <a>Введите регион</a>
            <input type='text' value={region} onChange={(e) => setRegion(e.target.value)} maxLength='50' placeholder='Регион' />

                <div className={styles.limitLine}></div>

            <a>Введите дату судебного заседания</a>
            <input type='date' value={dateCourt ? dateCourt.split('T')[0] : ''} onChange={(e) => setDateCourt(e.target.value)} required />

            <a>Введите дату отправки кандидатуры в суд</a>
            <input type='date' value={dateSubmissionCandidate ? dateSubmissionCandidate.split('T')[0] : ''} onChange={(e) => setDateSubmissionCandidate(e.target.value)} required />

            {userId && <>
                <a>Введите дату назначения арбитражного управляющего</a>
                <input type='date' value={dateAMAppointment ? dateAMAppointment.split('T')[0] : ''} onChange={(e) => setDateAMAppointment(e.target.value)} required />
            </>}

                <div className={styles.limitLine}></div>

            <a>Введите дату начала отсчета</a>
            <input type='date' value={dateStart ? dateStart.split('T')[0] : ''} onChange={(e) => setDateStart(e.target.value)} required />

            <a>Введите конечную дату</a>
            <a className={styles.description}>если хотите изменить в обход системы (не рекомендовано).</a>
            <a className={styles.description}>чтобы дата изменилась на указанную необходимо не изменять этап исполнения</a>
            <input type='date' value={dateEnd ? dateEnd.split('T')[0] : ''} onChange={(e) => setDateEnd(e.target.value)} required />
            
            
            {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
            <button className='button maxWidth black' type='button' onClick={() => changeCaseData()}>Изменить</button>
            <a className='description'>Можно подтвердить изменение нажатием кнопки Enter</a>
        </>
        )
    )
}

export default ChangeDataCase;